import { http } from "./http";

export type EasyRetailReportListItem = {
  id: string;
  posCode?: string | null;
  hostname?: string | null;
  source: string;
  status: string;
  summary: {
    overallStatus?: string;
    headline?: string;
    easyRetailDetected?: boolean;
    firebirdDbFound?: boolean;
    scaleTicketsFound?: number;
    gapCounts?: { high: number; medium: number; low: number; info: number };
  };
  analyzedAt: string;
  createdAt: string;
  location?: string | null;
};

export type EasyRetailGap = {
  id: string;
  severity: "HIGH" | "MEDIUM" | "LOW" | "INFO" | string;
  area: string;
  title: string;
  detail: string;
  easyRetailStatus?: string;
  natStatus?: string;
  action?: string;
};

export type EasyRetailReportDetail = {
  ok: boolean;
  report: {
    id: string;
    posCode?: string | null;
    hostname?: string | null;
    source: string;
    status: string;
    summary: Record<string, unknown>;
    findings: Record<string, unknown>;
    gaps: EasyRetailGap[];
    recommendations?: {
      nextSteps?: Array<{ priority: string; title: string; action: string }>;
      phases?: string[];
    };
    natSnapshot?: Record<string, unknown>;
    rawPayload?: Record<string, unknown>;
    analyzedAt: string;
    createdAt: string;
    posDevice?: {
      code: string;
      name: string;
      location?: { name: string; code: string };
    } | null;
  };
};

export const easyRetailApi = {
  list(token: string, limit = 30) {
    return http<{ ok: boolean; items: EasyRetailReportListItem[] }>(
      `/pos/easy-retail/analysis?limit=${limit}`,
      { method: "GET" },
      token,
    );
  },
  getById(token: string, id: string) {
    return http<EasyRetailReportDetail>(`/pos/easy-retail/analysis/${id}`, { method: "GET" }, token);
  },
};
